import { FC } from 'react';
import {
  ThresholdResult,
  useDrawersContext,
  WbTag,
} from '@agilelab/plugin-wb-platform';
import { TableCell, TableRow, Typography } from '@material-ui/core';
import { Task } from '../../EditorPage/types';
import { useReleaseDetailPageContext } from '../context/useReleaseDetailPageContext';
import { useStyles } from './styles';
import { MetricDetailDrawerContent } from '../../common';
import { MetricGql } from '@agilelab/plugin-wb-governance-common';
import { toGovernanceMetric } from '@agilelab/plugin-wb-governance';

interface Props {
  task: Task;
  metric: MetricGql;
}

export const MetricRow: FC<Props> = ({ task, metric }) => {
  const classes = useStyles();
  const { toggleBoolean } = useDrawersContext();
  const { setValidationTestResultDetailContent } =
    useReleaseDetailPageContext();
  const onRowClick = () => {
    setValidationTestResultDetailContent(
      <MetricDetailDrawerContent
        task={task}
        metric={toGovernanceMetric(metric)}
      />,
    );
    toggleBoolean(1);
  };

  return (
    <TableRow onClick={onRowClick} className={classes.row}>
      <TableCell width="20%" align="left">
        <ThresholdResult
          value={task.metricSpecificResult?.value || 0}
          result={task.metricSpecificResult?.threshold}
          hasError={task.errors && task.errors.length > 0}
        />
      </TableCell>
      <TableCell width="30%">
        <Typography style={{ fontWeight: 700 }}>
          {metric.name} - {metric.version}
        </Typography>
      </TableCell>
      <TableCell width="30%">
        <Typography>{metric.description}</Typography>
      </TableCell>
      <TableCell align="right" width="20%">
        <WbTag
          tag={{
            tagFQN: 'Metric',
          }}
        />
      </TableCell>
    </TableRow>
  );
};
